module.exports = __webpack_public_path__ + "fonts/7062b4ff-265a-4366-b34f-443ec5cc2dad.91729655.ttf";